// function load_cart() {
//   fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
//     .then((response) => response.text())
//     .then((responseText) => {

//       const cartid = 'cart-drawer';
//       const html = new DOMParser().parseFromString(responseText, 'text/html');
//       const destination = document.querySelector('.cart-sidebar');
//       const source = html.getElementById(cartid);

//       if (source && destination) {
//         destination.innerHTML = source.innerHTML;
//       }

//       /* ===============================
//          REMOVE BUTTON
//       =============================== */
//       document.querySelectorAll('.item-remove').forEach(function (cartRemove) {
//         const line = cartRemove.dataset.line;
//         cartRemove.addEventListener('click', function () {
//           updateCartItemQuantity(line, 0);
//         });
//       });

//       /* ===============================
//          PLUS / MINUS BUTTONS
//       =============================== */
//       document.querySelectorAll('.item-row').forEach(function (itemRow) {

//         const minusBtn = itemRow.querySelector('.qty-minus');
//         const plusBtn  = itemRow.querySelector('.qty-plus');
//         const qtyInput = itemRow.querySelector('.qty-input');
//         const removeBtn = itemRow.querySelector('.item-remove');

//         if (!qtyInput || !removeBtn) return;

//         const line = removeBtn.dataset.line;

//         // PLUS
//         if (plusBtn) {
//           plusBtn.addEventListener('click', function () {
//             const currentQty = parseInt(qtyInput.value, 10) || 1;
//             updateCartItemQuantity(line, currentQty + 1);
//           });
//         }

//         // MINUS
//         if (minusBtn) {
//   minusBtn.addEventListener('click', function () {
//     const currentQty = parseInt(qtyInput.value, 10) || 1;
//     if (currentQty > 1) {
//       updateCartItemQuantity(line, currentQty - 1);
//     }
//     // qty = 1 → do nothing, use the delete button to remove
//   });
// }
//       });

//       /* ===============================
//          CART DRAWER OPEN / CLOSE
//       =============================== */
//       document.querySelectorAll('.header-cart').forEach(function (cartButton) {
//         cartButton.addEventListener('click', function () {
//           document.body.classList.add('open-drawer');
//           document.body.classList.remove('open-menu', 'open-search', 'open-sort', 'open-filter');
//         });
//       });

//       document.querySelectorAll('.overlay-box, .cart-drawer-close').forEach(function (cartButton) {
//         cartButton.addEventListener('click', function () {
//           document.body.classList.remove('open-drawer', 'open-menu', 'open-search', 'open-sort', 'open-filter');
//         });
//       });

//       /* ===============================
//          UPDATE CART COUNT
//       =============================== */
//       fetch('/cart.js')
//         .then((resp) => resp.json())
//         .then(function (data) {
//           const cartCountEl = document.querySelector('.cart-count');
//           if (!cartCountEl) return;

//           if (data.item_count > 0) {
//             cartCountEl.innerHTML = data.item_count;
//           } else {
//             cartCountEl.innerHTML = '';
//           }
//         })
//         .catch(console.error);
//     });
// }

// /* ===============================
//    UPDATE CART ITEM QUANTITY
// =============================== */
// function updateCartItemQuantity(line, quantity) {
//   fetch('/cart/change.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify({
//       line: line,
//       quantity: quantity
//     })
//   })
//     .then((response) => response.json())
//     .then(() => {
//       load_cart(); // 🔥 reload cart on success
//     })
//     .catch((error) => {
//       console.error('Error updating cart:', error);
//     });
// }

// /* ===============================
//    INITIAL LOAD
// =============================== */
// load_cart();



/* ===============================
   LOAD CART DRAWER
=============================== */
function load_cart() {
  fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
    .then((response) => response.text())
    .then((responseText) => {

      const cartid = 'cart-drawer';
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.querySelector('.cart-sidebar');
      const source = html.getElementById(cartid);

      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }

      /* REMOVE BUTTON */
      document.querySelectorAll('.item-remove').forEach(function (cartRemove) {
        const line = cartRemove.dataset.line;

        cartRemove.addEventListener('click', function () {
          updateCartItemQuantity(line, 0);
        });
      });

      /* PLUS / MINUS */
      document.querySelectorAll('.item-row').forEach(function (itemRow) {

        const minusBtn = itemRow.querySelector('.qty-minus');
        const plusBtn = itemRow.querySelector('.qty-plus');
        const qtyInput = itemRow.querySelector('.qty-input');
        const removeBtn = itemRow.querySelector('.item-remove');

        if (!qtyInput || !removeBtn) return;

        const line = removeBtn.dataset.line;

        if (plusBtn) {
          plusBtn.addEventListener('click', function () {
            const currentQty = parseInt(qtyInput.value, 10) || 1;
            updateCartItemQuantity(line, currentQty + 1);
          });
        }

        if (minusBtn) {
          minusBtn.addEventListener('click', function () {
            const currentQty = parseInt(qtyInput.value, 10) || 1;

            if (currentQty > 1) {
              updateCartItemQuantity(line, currentQty - 1);
            }
          });
        }
      });

      updateCartCount();
      if (typeof initTrendingSwiper === 'function') {
        initTrendingSwiper();
      }
    })
    .catch(console.error);
}

/* ===============================
   UPDATE CART COUNT
=============================== */
function updateCartCount() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {

      document.querySelectorAll('.cart-count').forEach((countEl) => {
        countEl.textContent = cart.item_count > 0 ? cart.item_count : '';
      });

    })
    .catch(console.error);
}

/* ===============================
   UPDATE CART ITEM
=============================== */
function updateCartItemQuantity(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    })
  })
    .then((response) => response.json())
    .then(() => {
      load_cart();
    })
    .catch((error) => {
      console.error('Error updating cart:', error);
    });
}

/* ===============================
   AJAX ADD TO CART
=============================== */
document.addEventListener('click', async function (e) {

  const button = e.target.closest('.trending-add-cart');

  if (!button) return;

  e.preventDefault();

  const variantId = button.dataset.variantId;

  if (!variantId) {
    console.error('Variant ID not found');
    return;
  }

  button.disabled = true;

  try {

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (!response.ok) {
      throw new Error('Failed to add item');
    }

    await response.json();

    // Reload cart drawer
    load_cart();

    // Open drawer automatically
    document.body.classList.add('open-drawer');
    document.body.classList.remove(
      'open-menu',
      'open-search',
      'open-sort',
      'open-filter'
    );

  } catch (error) {
    console.error('Add to cart error:', error);
  } finally {
    button.disabled = false;
  }
});

/* ===============================
   DRAWER OPEN
=============================== */
document.addEventListener('click', function(e){

  if(e.target.closest('.header-cart')){
    document.body.classList.add('open-drawer');
    document.body.classList.remove(
      'open-menu',
      'open-search',
      'open-sort',
      'open-filter'
    );
  }

  if(
    e.target.closest('.overlay-box') ||
    e.target.closest('.cart-drawer-close')
  ){
    document.body.classList.remove(
      'open-drawer',
      'open-menu',
      'open-search',
      'open-sort',
      'open-filter'
    );
  }

});

/* ===============================
   INITIAL LOAD
=============================== */
document.addEventListener('DOMContentLoaded', function () {
  load_cart();
});
